module.exports = __webpack_public_path__ + "img/yisheng.51ae9475.svg";